module.exports = __webpack_public_path__ + "static/media/IMG_7586_.d2184dfa.png";